/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/ForesightScenarioReport', 'model/ForesightScenario'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('../model/ForesightScenarioReport'), require('../model/ForesightScenario'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.ForesightScenarioApi = factory(root.ForStractionServiceApi.ApiClient, root.ForStractionServiceApi.ForesightScenarioReport, root.ForStractionServiceApi.ForesightScenario);
  }
}(this, function(ApiClient, ForesightScenarioReport, ForesightScenario) {
  'use strict';

  /**
   * ForesightScenario service.
   * @module api/ForesightScenarioApi
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new ForesightScenarioApi. 
   * @alias module:api/ForesightScenarioApi
   * @class
   * @param {module:ApiClient} apiClient Optional API client implementation to use,
   * default to {@link module:ApiClient#instance} if unspecified.
   */
  var exports = function(apiClient) {
    this.apiClient = apiClient || ApiClient.instance;


    /**
     * Callback function to receive the result of the foresightScenarioAddPut operation.
     * @callback module:api/ForesightScenarioApi~foresightScenarioAddPutCallback
     * @param {String} error Error message, if any.
     * @param {'Integer'} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * add
     * @param {String} _4SAPIAppID 
     * @param {module:model/ForesightScenarioReport} body 
     * @param {Object} opts Optional parameters
     * @param {Boolean} opts.autoSubdivide  (default to false)
     * @param {Boolean} opts.calculate  (default to false)
     * @param {module:api/ForesightScenarioApi~foresightScenarioAddPutCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link 'Integer'}
     */
    this.foresightScenarioAddPut = function(_4SAPIAppID, body, opts, callback) {
      opts = opts || {};
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling foresightScenarioAddPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling foresightScenarioAddPut";
      }


      var pathParams = {
      };
      var queryParams = {
        'autoSubdivide': opts['autoSubdivide'],
        'calculate': opts['calculate']
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = 'Integer';

      return this.apiClient.callApi(
        '/ForesightScenario/add', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the foresightScenarioCalculateCashflowGet operation.
     * @callback module:api/ForesightScenarioApi~foresightScenarioCalculateCashflowGetCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * calculateCashflow
     * @param {String} _4SAPIAppID 
     * @param {Integer} scenarioID 
     * @param {module:api/ForesightScenarioApi~foresightScenarioCalculateCashflowGetCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.foresightScenarioCalculateCashflowGet = function(_4SAPIAppID, scenarioID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling foresightScenarioCalculateCashflowGet";
      }

      // verify the required parameter 'scenarioID' is set
      if (scenarioID == undefined || scenarioID == null) {
        throw "Missing the required parameter 'scenarioID' when calling foresightScenarioCalculateCashflowGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'scenarioID': scenarioID
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/ForesightScenario/calculateCashflow', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the foresightScenarioCalculateDataGet operation.
     * @callback module:api/ForesightScenarioApi~foresightScenarioCalculateDataGetCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * calculateData
     * @param {String} _4SAPIAppID 
     * @param {Integer} scenarioID 
     * @param {module:api/ForesightScenarioApi~foresightScenarioCalculateDataGetCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.foresightScenarioCalculateDataGet = function(_4SAPIAppID, scenarioID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling foresightScenarioCalculateDataGet";
      }

      // verify the required parameter 'scenarioID' is set
      if (scenarioID == undefined || scenarioID == null) {
        throw "Missing the required parameter 'scenarioID' when calling foresightScenarioCalculateDataGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'scenarioID': scenarioID
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/ForesightScenario/calculateData', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the foresightScenarioCloneScenarioGet operation.
     * @callback module:api/ForesightScenarioApi~foresightScenarioCloneScenarioGetCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ForesightScenarioReport} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * cloneScenario
     * @param {String} _4SAPIAppID 
     * @param {Integer} scenarioID 
     * @param {String} clonedScenarioName 
     * @param {module:api/ForesightScenarioApi~foresightScenarioCloneScenarioGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ForesightScenarioReport}
     */
    this.foresightScenarioCloneScenarioGet = function(_4SAPIAppID, scenarioID, clonedScenarioName, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling foresightScenarioCloneScenarioGet";
      }

      // verify the required parameter 'scenarioID' is set
      if (scenarioID == undefined || scenarioID == null) {
        throw "Missing the required parameter 'scenarioID' when calling foresightScenarioCloneScenarioGet";
      }

      // verify the required parameter 'clonedScenarioName' is set
      if (clonedScenarioName == undefined || clonedScenarioName == null) {
        throw "Missing the required parameter 'clonedScenarioName' when calling foresightScenarioCloneScenarioGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'scenarioID': scenarioID,
        'clonedScenarioName': clonedScenarioName
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = ForesightScenarioReport;

      return this.apiClient.callApi(
        '/ForesightScenario/cloneScenario', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the foresightScenarioDeleteGet operation.
     * @callback module:api/ForesightScenarioApi~foresightScenarioDeleteGetCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * delete
     * @param {String} _4SAPIAppID 
     * @param {Integer} scenarioID 
     * @param {module:api/ForesightScenarioApi~foresightScenarioDeleteGetCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.foresightScenarioDeleteGet = function(_4SAPIAppID, scenarioID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling foresightScenarioDeleteGet";
      }

      // verify the required parameter 'scenarioID' is set
      if (scenarioID == undefined || scenarioID == null) {
        throw "Missing the required parameter 'scenarioID' when calling foresightScenarioDeleteGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'scenarioID': scenarioID
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/ForesightScenario/delete', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the foresightScenarioEditPut operation.
     * @callback module:api/ForesightScenarioApi~foresightScenarioEditPutCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * edit
     * @param {String} _4SAPIAppID 
     * @param {module:model/ForesightScenario} body 
     * @param {module:api/ForesightScenarioApi~foresightScenarioEditPutCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.foresightScenarioEditPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling foresightScenarioEditPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling foresightScenarioEditPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/ForesightScenario/edit', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the foresightScenarioExportDataGet operation.
     * @callback module:api/ForesightScenarioApi~foresightScenarioExportDataGetCallback
     * @param {String} error Error message, if any.
     * @param {'String'} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * exportData
     * @param {String} _4SAPIAppID 
     * @param {Integer} scenarioID 
     * @param {module:api/ForesightScenarioApi~foresightScenarioExportDataGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link 'String'}
     */
    this.foresightScenarioExportDataGet = function(_4SAPIAppID, scenarioID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling foresightScenarioExportDataGet";
      }

      // verify the required parameter 'scenarioID' is set
      if (scenarioID == undefined || scenarioID == null) {
        throw "Missing the required parameter 'scenarioID' when calling foresightScenarioExportDataGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'scenarioID': scenarioID
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = 'String';

      return this.apiClient.callApi(
        '/ForesightScenario/exportData', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the foresightScenarioLoadAllGet operation.
     * @callback module:api/ForesightScenarioApi~foresightScenarioLoadAllGetCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/ForesightScenarioReport>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * loadAll
     * @param {String} _4SAPIAppID 
     * @param {module:api/ForesightScenarioApi~foresightScenarioLoadAllGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/ForesightScenarioReport>}
     */
    this.foresightScenarioLoadAllGet = function(_4SAPIAppID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling foresightScenarioLoadAllGet";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = [ForesightScenarioReport];

      return this.apiClient.callApi(
        '/ForesightScenario/loadAll', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the foresightScenarioLoadGet operation.
     * @callback module:api/ForesightScenarioApi~foresightScenarioLoadGetCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ForesightScenarioReport} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * load
     * @param {String} _4SAPIAppID 
     * @param {Integer} scenarioID 
     * @param {module:api/ForesightScenarioApi~foresightScenarioLoadGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ForesightScenarioReport}
     */
    this.foresightScenarioLoadGet = function(_4SAPIAppID, scenarioID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling foresightScenarioLoadGet";
      }

      // verify the required parameter 'scenarioID' is set
      if (scenarioID == undefined || scenarioID == null) {
        throw "Missing the required parameter 'scenarioID' when calling foresightScenarioLoadGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'scenarioID': scenarioID
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = ForesightScenarioReport;

      return this.apiClient.callApi(
        '/ForesightScenario/load', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
  };

  return exports;
}));
